import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableHeader from '@projectK/components/TableHeader';
import { Fonts } from '@projectK/constants/AppEnums';
import { isActualSuperAdmin, isParent,isActualAdmin } from '@projectK/context/RolesProvider';

const TableHeading = ({ user }) => {
  return (
    <TableHeader
      sx={{
        position: 'relative',
        '& .tableCell': {
          fontSize: 13,
          padding: 2,
          paddingTop: 0,
          fontWeight: Fonts.BOLD,
          whiteSpace: 'nowrap',
          '&:first-of-type': {
            paddingLeft: 5,
          },
          '&:last-of-type': {
            paddingRight: 5,
          },
        },
      }}
    >
      <TableCell align='left' className='tableCell'>
        Email
      </TableCell>
      <TableCell align='center' className='tableCell'>
        First Name
      </TableCell>
      <TableCell align='center' className='tableCell'>
        Last Name
      </TableCell>
      {(isParent(user) ||isActualSuperAdmin(user) || isActualAdmin(user)) && (
        <TableCell align='center' className='tableCell'>
          Actions
        </TableCell>
      )}
    </TableHeader>
  );
};

export default TableHeading;
